export default "__VITE_ASSET__f0097ef5__"